{
  "INTEGRATION_APPS": {
    "FETCHING": "Henter Integrationer",
    "NO_HOOK_CONFIGURED": "Der er ingen {integrationId} integrationer konfigureret på denne konto.",
    "HEADER": "Applikationer",
    "STATUS": {
      "ENABLED": "Aktiveret",
      "DISABLED": "Deaktiveret"
    },
    "CONFIGURE": "Konfigurer",
    "ADD_BUTTON": "Tilføj en ny krog",
    "DELETE": {
      "TITLE": {
        "INBOX": "Bekræft sletning",
        "ACCOUNT": "Afbryd"
      },
      "MESSAGE": {
        "INBOX": "Er du sikker på du vil slette?",
        "ACCOUNT": "Er du sikker på at du afbryder?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ja, Slet",
        "ACCOUNT": "Ja, Afbryd"
      },
      "CANCEL_BUTTON_TEXT": "Annuller",
      "API": {
        "SUCCESS_MESSAGE": "Hook slettet",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
      }
    },
    "LIST": {
      "FETCHING": "Henter integrationshoks",
      "INBOX": "Indbakke",
      "EDIT": {
        "BUTTON_TEXT": "Rediger"
      },
      "DELETE": {
        "BUTTON_TEXT": "Slet"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Vælg Indbakke",
          "PLACEHOLDER": "Vælg Indbakke"
        },
        "SUBMIT": "Opret",
        "CANCEL": "Annuller"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook tilføjet",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
      }
    },
    "EDIT": {
      "TITLE": "Rediger {name}",
      "FORM": {
        "SUBMIT": "Opdater",
        "CANCEL": "Annuller"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrationshook opdateret",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til chatserveren, prøv igen senere"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Tilslut"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Afbryd"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synkroniser e-mails og webchats til din Daktela-konto.",
      "RETINO": "Retino skaber overblik i håndteringen af returneringer og reklamationer.",
      "MAILSHIP": "Mailship er et system til styring af lager og ordreekspedition. Slå ordrestatus, sporing og forsendelsesoplysninger op.",
      "RAYNET": "Forbind din Raynet CRM-konto for at få adgang til dine kundedata. Tilføj en forbindelse med dit Raynet-brugernavn og API-token."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Test forbindelse",
      "SUCCESS": "Forbindelse oprettet",
      "ERROR": "Forbindelsen mislykkedes. Tjek venligst dine loginoplysninger."
    }
  }
}
